import { AbstractControl, ValidatorFn } from '@angular/forms';

export function emptyStringValidator(controlName: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (!controlName) {
            return null;
        }
        if (isEmptyString(control.value)) {
            const error: any = {};
            error[controlName] = false;
            return error;
        }
        return null;
    };
}

export function isEmptyString(value: string) {
    return !(value || '').trim();
}
